const NS = 'VIEWS';

export const SET_NAV_DRAWER_IS_OPEN = `${NS}/SET_NAV_DRAWER_IS_OPEN`;

export const SET_DISPLAYED_WEEK = `${NS}/SET_DISPLAYED_WEEK`;

export const SET_DISPLAYED_MONTH = `${NS}/SET_DISPLAYED_MONTH`;

export const SET_DEVOTIONAL_GROUP_LEADER = `${NS}/SET_DEVOTIONAL_GROUP_LEADER`;

export const SELECTED_DEVOTIONAL_GROUP = `${NS}/SELECTED_DEVOTIONAL_GROUP`;

export const SET_ATTENDANCE = `${NS}/SET_ATTENDANCE`;

export const SET_IS_INITIAL_LOADING = `${NS}/SET_IS_INITIAL_LOADING`;

export const SET_LOGGED_IN_DEVOTEE_ID = `${NS}/SET_LOGGED_IN_DEVOTEE_ID`;

export const SET_IS_AUTHORIZED = `${NS}/SET_IS_AUTHORIZED`;

export const SET_IS_AUTHENTICATED = `${NS}/SET_IS_AUTHENTICATED`;

export const INITIALIZE_APP = `${NS}/INITIALIZE_APP`;
